export default __webpack_public_path__ + "static/media/shield-filled.fb74d0b8.svg";